import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'
import { GbDashboardSharedUiModule } from '../gb-dashboard-shared-ui.module'

export interface MessagePlaceholder {
  key: string
  description: string
}

@Component({
  selector: 'gb-message-placeholders',
  templateUrl: './gb-message-placeholders.component.html',
  styleUrls: ['./gb-message-placeholders.component.scss'],
  imports: [GbDashboardSharedUiModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbMessagePlaceholdersComponent {
  readonly placeholders = input.required<MessagePlaceholder[]>()
  readonly loaded = input<boolean>(true)

  protected readonly showPlaceholders = signal(false)

  protected togglePlaceholders(): void {
    this.showPlaceholders.update((show) => !show)
  }
}
